"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DynamicSelect_1 = require("../../DateFilter/DynamicSelect/DynamicSelect");
var react_intl_1 = require("react-intl");
var utils_1 = require("./utils");
var ValueDropdownComponent = function (_a) {
    var selectedValue = _a.selectedValue, onSelect = _a.onSelect, intl = _a.intl;
    var getDropdownItems = function (value) { return utils_1.sanitizeInput(value, intl); };
    return (react_1.default.createElement(DynamicSelect_1.DynamicSelect, { getItems: getDropdownItems, onChange: onSelect, value: selectedValue, className: "gd-rf-value-dropdown-button s-rf-value-dropdown-button", optionClassName: "s-rf-value-dropdown-item", customValueValidator: utils_1.sanitizeCustomInput }));
};
exports.ValueDropdown = react_intl_1.injectIntl(ValueDropdownComponent);
//# sourceMappingURL=ValueDropdown.js.map